import { useToggle } from '@sdk/common/hooks/useToggle';

import { EmojiPicker } from '@web/components/EmojiPicker/EmojiPicker';
import { PRIMARY_EMOJIS } from '@web/conversations/Reactions/consts/primaryEmojis';
import ReactionsSVG from '@web/assets/svg/UI/reactions.svg';

import { OpenPickerButton, Option, Select } from './reactionSelect.styles';

export type Props = {
  handleSelect: (reaction: string) => void;
};

export const ReactionSelect = ({ handleSelect }: Props) => {
  const { isOff, setOn } = useToggle(false);

  return isOff ? (
    <Select>
      {PRIMARY_EMOJIS.map((reaction) => (
        <Option key={reaction} onClick={() => handleSelect(reaction)}>
          {reaction}
        </Option>
      ))}
      <OpenPickerButton onClick={setOn}>
        <ReactionsSVG />
      </OpenPickerButton>
    </Select>
  ) : (
    <EmojiPicker
      onSelect={(emoji) => {
        handleSelect(emoji.native);
      }}
    />
  );
};
